import type { UserResponseProvider } from './userResponseProvider';
import type { UserResponseStatus } from './userResponseStatus';

export interface UserResponse {
  /** 생성 시간 */
  createdAt: string;
  /** 이메일 주소 */
  email: string;
  /** 전체 이름 */
  fullName?: string;
  /** 사용자 ID */
  id: string;
  /** 마지막 로그인 시간 */
  lastLoginAt?: string;
  /** 프로필 이미지 URL */
  profileImageUrl?: string;
  /** 인증 제공자 */
  provider: UserResponseProvider;
  /** 사용자 권한 목록 */
  roles: string[];
  /** 계정 상태 */
  status: UserResponseStatus;
  /** 수정 시간 */
  updatedAt?: string;
  /** 사용자명 */
  username: string;
}
